import React, { useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import th from "date-fns/locale/th";
import "react-datepicker/dist/react-datepicker.css";
import CustomerModal from "../../components/Modal/Sale/CustomersModal";
import CalendarWrapper from "../../components/Calendar/CalendarWrapper";
import CalendarSalesSchedule from "../../components/Calendar/CalendarSalesSchedule";

//  ลงทะเบียน locale ภาษาไทย
registerLocale("th", th);

export default function SearchAndFilter({
  onSearch,
  onCreate,
  onImport,
  total = 0,
  provinces = [],
  customers = [],
  activeGroup,
  setActiveGroup,
  todayCount = 0,
  mineCount = 0,
  unassignedCount = 0,
}) {
  const [filters, setFilters] = useState({
    keyword: "",
    dateType: "lastContact",
    dateFrom: null,
    dateTo: null,
    province: "",
    customer: [],
    customerType: "",
    contactStatus: "",
  });

  const [openCustomerModal, setOpenCustomerModal] = useState(false);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [openSalesCalendar, setOpenSalesCalendar] = useState(false); //  ใหม่

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch(filters);
  };

  const formatThaiDateFull = (date) => {
    if (!date) return "";

    const days = ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัส", "ศุกร์", "เสาร์"];
    const months = [
      "มกรา",
      "กุมภา",
      "มีนา",
      "เมษา",
      "พฤษภา",
      "มิถุนา",
      "กรกฎา",
      "สิงหา",
      "กันยา",
      "ตุลา",
      "พฤศจิกา",
      "ธันวา",
    ];

    const dayName = days[date.getDay()];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = (date.getFullYear() + 543).toString().slice(-2);

    return `${dayName} ${day} ${month} ${year}`;
  };

  const CustomDateInput = React.forwardRef(({ value, onClick, displayValue }, ref) => (
    <input
      onClick={onClick}
      ref={ref}
      readOnly
      value={displayValue || ""}
      className="border rounded-full px-3 h-[32px] text-center cursor-pointer text-gray-600"
    />
  ));

  return (
    <div className="space-y-0">
      <div className="flex items-center justify-between mt-0">

        {/* 👈 ซ้าย : หัวข้อ + ปุ่มกลุ่ม */}
        <div className="flex items-center gap-4">

          {/* หัวข้อ */}
          <h2 className="flex items-center gap-2 font-bold text-[#2A2A2A] !text-[28px]">
            รายชื่อลูกค้า ({total})
          </h2>

          {/* ปุ่มกลุ่มต่อจากหัวข้อ */}
          <div className="flex items-center gap-2">

            <button
              className={`min-w-[150px] px-4 py-1.5 rounded-full text-white text-sm font-medium shadow text-center
                ${activeGroup === "all" ? "bg-[#E13F57]" : "bg-[#E13F57]/70 hover:bg-[#E13F57]"}`}
              onClick={() => setActiveGroup("all")}
            >
              ทั้งหมด ({total})
            </button>

            <button
              className={`min-w-[150px] px-4 py-1.5 rounded-full text-white text-sm font-medium shadow text-center
                ${activeGroup === "today" ? "bg-blue-600" : "bg-blue-500 hover:bg-blue-600"}`}
              onClick={() => setActiveGroup("today")}
            >
              todo ({todayCount})
            </button>

            <button
              className={`min-w-[150px] px-4 py-1.5 rounded-full text-white text-sm font-medium shadow text-center
                ${activeGroup === "mine" ? "bg-green-600" : "bg-green-500 hover:bg-green-600"}`}
              onClick={() => setActiveGroup("mine")}
            >
              ลูกค้าของฉัน ({mineCount})
            </button>
          </div>
        </div>

        {/* 👉 ขวา : ปุ่มสร้าง + import */}
        <div className="flex gap-2">
          <button
            onClick={onCreate}
            className="flex items-center justify-center gap-[10px] h-[40px] w-[220px] rounded-[19.5px] border border-[#598AE4] bg-[#2857F2] text-white text-[14px] font-semibold hover:opacity-90 transition"
          >
            <img src="/assets/img/icon/gridicons_add.svg" className="w-5 h-5" />
            <span>สร้างข้อมูลลูกค้า</span>
          </button>

          <button
            onClick={onImport}
            className="flex items-center justify-center gap-[10px] h-[40px] w-[220px] rounded-[19.5px] border border-[#00CF03] bg-[#00CF03] text-white text-[14px] font-semibold hover:opacity-90 transition"
          >
            <img src="/assets/img/icon/gridicons_add.svg" className="w-5 h-5" />
            <span>Import ข้อมูลลูกค้า</span>
          </button>
        </div>
      </div>


      <div className="flex items-end justify-between gap-4">
        <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-2 text-sm flex-1"></form>
      </div>

      <CustomerModal
        isOpen={openCustomerModal}
        onClose={() => setOpenCustomerModal(false)}
        customers={customers}
        selectedIds={selectedCustomers.map((c) => c.AR_Id)}
        onSelect={(list) => {
          setSelectedCustomers(list);
          setFilters({ ...filters, customer: list.map((c) => c.AR_Id) });
          setOpenCustomerModal(false);
        }}
      />

      
    </div>
  );
}
